import moment from 'moment';

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const formatDateForTable = (dateString) => {
  const date = new Date(dateString);
  const formattedDate = moment(date).format('MMM D');
  const formattedTime = moment(date).utc().format('HH:mm:ss');

  return { formattedDate, formattedTime };
};

export const dateTimeFormat = (date) =>
  date ? moment(date).format('HH:mm:ss MMM D') : '-';
